import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "ma--top-1 sites--container" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row ma--bottom-1"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus btn--icon__prefix" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Add Site", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-briefcase btn--icon__prefix" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Add Subscription", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "card-content" }
const _hoisted_16 = { class: "table table--striped" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Name", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Url", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Credits", -1)
const _hoisted_20 = {
  key: 0,
  class: "text--align-left"
}
const _hoisted_21 = {
  key: 1,
  class: "text--align-left"
}
const _hoisted_22 = {
  key: 2,
  class: "text--align-left"
}
const _hoisted_23 = { class: "text--align-left" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text--align-left" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "text--align-left" }
const _hoisted_28 = ["data-tooltip"]
const _hoisted_29 = ["data-tooltip"]
const _hoisted_30 = {
  key: 2,
  class: "text--align-left"
}
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-code" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-anchor" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick", "data-tooltip"]
const _hoisted_38 = ["onClick", "data-tooltip", "disabled"]
const _hoisted_39 = ["onClick", "data-tooltip"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_CreatSite = _resolveComponent("CreatSite")!
  const _component_PixelTracking = _resolveComponent("PixelTracking")!
  const _component_PluginTracking = _resolveComponent("PluginTracking")!
  const _component_StripeSubscription = _resolveComponent("StripeSubscription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.request._loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn--primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCreateSiteModel = true))
                    }, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn--primary bottom right",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSubscription())),
                      "data-tooltip": "Add a new subscription to the project."
                    }, _hoisted_14))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_20, "Status"))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, "Actions"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: ($event: any) => (_ctx.updateSiteId(item))
                          }, _toDisplayString(item.siteName), 9, _hoisted_24)
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: item.siteUrl
                          }, _toDisplayString(item.siteUrl), 9, _hoisted_26)
                        ]),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatNumber2Decimals(item.credits)), 1),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: _normalizeClass(["text--align-left legend__item", {
                      'before--color-blue': item.status == 'APPROVED',
                      'before--color-red': item.status == 'UNAPPROVED',
                      'before--color-purple': item.status == 'PAUSED',
                    }])
                            }, [
                              _createElementVNode("div", {
                                "data-tooltip": 
                        item.status == 'APPROVED'
                          ? 'The pixel has deployed successfully.'
                          : item.status == 'PAUSED'
                          ? 'The site is paused'
                          : 'The pixel has not yet deployed.'
                      
                              }, _toDisplayString(item.status), 9, _hoisted_28)
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 1,
                              class: _normalizeClass(["text--align-left legend__item", {
                      'before--color-blue': item.enabledFlag == true,
                      'before--color-red': item.enabledFlag == false,
                    }])
                            }, [
                              _createElementVNode("div", {
                                "data-tooltip": item.enabledFlag ? 'ACTIVE' : 'INACTIVE'
                              }, _toDisplayString(item.enabledFlag ? "ACTIVE" : "INACTIVE"), 9, _hoisted_29)
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                              _createElementVNode("button", {
                                class: "btn--inline btn--edit",
                                onClick: ($event: any) => (_ctx.getPixelInstallData(item.id,item.siteName)),
                                "data-tooltip": "Click to generate a pixel for this site.",
                                disabled: item.additionalInfo == null
                              }, _hoisted_33, 8, _hoisted_31),
                              _createElementVNode("button", {
                                class: "btn--inline btn--edit",
                                onClick: ($event: any) => (_ctx.showWordpressPluginInstall(item)),
                                "data-tooltip": "Click to generate wordpress plugin pixel setting."
                              }, _hoisted_36, 8, _hoisted_34),
                              (_ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass({ 'btn--inline btn btn--secondary top left ma--right-1':!_ctx.isStatCounterEnabled(item),
                                  'btn--inline btn btn--green top left ma--right-1':_ctx.isStatCounterEnabled(item),
                                  }),
                                    onClick: ($event: any) => (_ctx.setStatCounter(item)),
                                    "data-tooltip": 
                        (!_ctx.isStatCounterEnabled(item))
                          ? 'Enable Advanced Stats'
                          : 'Remove Advanced Stats'
                      
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa", {
                          'fa-ban': !_ctx.isStatCounterEnabled(item),
                          'fa-strikethrough': _ctx.isStatCounterEnabled(item),
                        }])
                                    }, null, 2)
                                  ], 10, _hoisted_37))
                                : _createCommentVNode("", true),
                              (_ctx.isAdmin || _ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn--inline btn--purple top left",
                                    onClick: ($event: any) => (_ctx.changeStatus(item)),
                                    "data-tooltip": 
                        item.status == 'PAUSED'
                          ? 'Start collecting data with tracking pixel'
                          : 'PAUSE temporarily disconnects the tracking pixel from collecting data'
                      ,
                                    disabled: item.status == 'UNAPPROVED'
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa", {
                          'fa-play': item.status == 'PAUSED',
                          'fa-pause': item.status != 'PAUSED',
                        }])
                                    }, null, 2)
                                  ], 8, _hoisted_38))
                                : _createCommentVNode("", true),
                              (_ctx.isAdmin || _ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn--inline btn--secondary top left ma--right-1",
                                    onClick: ($event: any) => (_ctx.changeActive(item)),
                                    "data-tooltip": 
                        item.enabledFlag
                          ? 'Make site Inactive'
                          : 'Make site active'
                      
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa", {
                          'fa-eye-slash': item.enabledFlag == true,
                          'fa-eye': item.enabledFlag == false,
                        }])
                                    }, null, 2)
                                  ], 8, _hoisted_39))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "btn--inline btn--delete",
                                onClick: ($event: any) => (_ctx.deleteSite(item)),
                                "data-tooltip": "Click to delete the site and the pixel."
                              }, _hoisted_42, 8, _hoisted_40)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.response.data.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_43, _hoisted_45))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.response)
                  ? (_openBlock(), _createBlock(_component_Pagination, {
                      key: 0,
                      totalResults: _ctx.response.pageInfo.totalResults,
                      totalPages: _ctx.response.pageInfo.totalPages,
                      showPage: _ctx.response.data.length,
                      onApplyPagination: _ctx.controlWithPagination
                    }, null, 8, ["totalResults", "totalPages", "showPage", "onApplyPagination"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleCreateSiteModel)
                  ? (_openBlock(), _createBlock(_component_CreatSite, {
                      key: 1,
                      onCloseSiteModel: _ctx.onCloseSiteModel
                    }, null, 8, ["onCloseSiteModel"]))
                  : _createCommentVNode("", true),
                (_ctx.togglePixelSiteModel)
                  ? (_openBlock(), _createBlock(_component_PixelTracking, {
                      key: 2,
                      pixelInstallCode: _ctx.pixelInstallCode,
                      pixelSiteName: _ctx.pixelSiteName,
                      onClosePixel: _ctx.closePixelModel
                    }, null, 8, ["pixelInstallCode", "pixelSiteName", "onClosePixel"]))
                  : _createCommentVNode("", true),
                (_ctx.togglePluginSiteModel)
                  ? (_openBlock(), _createBlock(_component_PluginTracking, {
                      key: 3,
                      pixelActivationItem: _ctx.pixelActivationItem,
                      isSuperAdmin: _ctx.isSuperAdmin,
                      onClosePixel: _ctx.closePluginModel
                    }, null, 8, ["pixelActivationItem", "isSuperAdmin", "onClosePixel"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleCreateSubscriptionModel)
                  ? (_openBlock(), _createBlock(_component_StripeSubscription, {
                      key: 4,
                      pixelActivationItem: _ctx.pixelActivationItem,
                      isSuperAdmin: _ctx.isAdmin,
                      onCloseCreateSubscriptionModel: _ctx.closeCreateSubscriptionModel
                    }, null, 8, ["pixelActivationItem", "isSuperAdmin", "onCloseCreateSubscriptionModel"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
  ]))
}